import React, { Component } from "react";
import { connect } from "react-redux";
import { Button } from "react-bootstrap";
import ImmutablePropTypes from "react-immutable-proptypes";
// import MoreInfo from './MoreInfo'
// import MoreDetails from "./MoreDetails";

import { generateLink, generateLinkToDebug, redirectTo } from "../Utils";

class GameListItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      MoreDetails: null,
    };

    this.toggleFavourite = this.toggleFavourite.bind(this);
  }

  launchGameDebugPage = (game) => {
    redirectTo(generateLinkToDebug(game));
  };

  launchGame = (game) => {
    console.log("Will launch game:", game);
    redirectTo(
      generateLink(game, this.props.launchOptions, this.props.urlLaunchOptions)
    );
  };

  getLaunchGameURL(game) {
    return generateLink(
      game,
      this.props.launchOptions,
      this.props.urlLaunchOptions
    );
  }

  toggleFavourite() {
    this.props.toggleFavourite(this.props.game);
  }

  handleToggle = async () => {
    const { open, MoreDetails } = this.state;
    if (!open && !MoreDetails) {
      // Dynamically import the component only on first open
      const module = await import("./MoreDetails");
      this.setState({ MoreDetails: module.default, open: true });
    } else {
      this.setState({ open: !open });
    }
  };

  render() {
    const { MoreDetails, open } = this.state;
    const game = this.props.game;

    return (
      <li className="list-group-item text-left col-xs-12">
        <div className="col-xs-12 button-wrapper">
          <div className="col-xs-8">
            <h3>
              <span>{game.get("game")}</span>
              <span className="small"> ({game.get("interface")}) </span>
              <span>
                <Button
                  onClick={() => this.launchGameDebugPage(game)}
                  bsSize="small"
                  bsStyle="link"
                >
                  debug page
                </Button>
              </span>
            </h3>
          </div>

          <div className="col-xs-4">
            <div className="pull-right actionables">
              <a
                href={this.getLaunchGameURL(game)}
                className="btn btn-lg btn-primary"
              >
                Launch
              </a>

              <span style={{ marginLeft: "20px" }}></span>
              <Button bsStyle="info" onClick={this.handleToggle}>
                {!open ? "+" : "-"}
              </Button>

              <button
                type="button"
                className="btn btn__star"
                onClick={this.toggleFavourite}
              >
                {this.props.isFavourite ? (
                  <i className="fas fa-star"></i>
                ) : (
                  <i className="far fa-star"></i>
                )}
              </button>
            </div>
          </div>
        </div>

        {/* Only render when open and after loaded */}
        {open && MoreDetails && (
          <MoreDetails
            open={open}
            game={game}
            config={this.props.config}
            urlLaunchOptions={this.props.urlLaunchOptions}
            launchOptions={this.props.launchOptions}
          />
        )}
      </li>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const currentState = state.environment_information;
  const isFavourite =
    currentState
      .get("favouriteGames")
      .findIndex(
        (favouriteGame) => favouriteGame.get("id") === ownProps.game.get("id")
      ) > -1;

  return { isFavourite };
};

const mapDispatchToProps = () => ({});

GameListItem.propTypes = {
  game: ImmutablePropTypes.map,
  config: ImmutablePropTypes.map,
  launchOptions: ImmutablePropTypes.map,
  urlLaunchOptions: ImmutablePropTypes.map,
};

export default connect(mapStateToProps, mapDispatchToProps)(GameListItem);



// WEBPACK FOOTER //
// ./src/components/GameListItem.js